import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Encounter, Practitioner } from 'src/models';
import { ambientApi } from 'src/services';

export type UseCreateEncounterPayload = {
  practitioner_id: Practitioner['practitioner_id'];
  description: string;
  start_time: string;
};

export const useCreateEncounter = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UseCreateEncounterPayload) =>
      ambientApi
        .post<Encounter>('/encounters', payload)
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['encounterList'] });
    },
  });
};
